// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2NaeT","itemTitle":"ClientEmergencyInfo_itemTitle__sfzC5","itemText":"ClientEmergencyInfo_itemText__2OSk6"};